const EChatStreamEventType = Object.freeze({
    Start: 0,
    Delta: 1,
    Complete: 2,
    Error: 3,
    File: 4
});

export default EChatStreamEventType;